<h1 mat-dialog-title>
  <button mat-button (click)="onNoClick()">Close</button>
</h1>
<div mat-dialog-content>
  <div
  *ngIf="viewform"
    [formGroup]="formWarehouseLocationAdd"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  >
    <mat-form-field
      appearance="fill"
      class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
    >
      <mat-label>Select Customer</mat-label>
      <mat-select
        formControlName="Customer"
        (selectionChange)="onselectchanger($event)"
      >
        <mat-option
          *ngFor="let item of PlaceOrderCustomer"
          [value]="item.key"
          >{{ item.value }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="viewLocation"
      appearance="fill"
      class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
    >
      <mat-label>Select location</mat-label>
      <mat-select formControlName="location">
        <mat-option *ngFor="let item of ArrayLocations" [value]="item.id">{{
          item.Location
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="viewProdust"
      appearance="fill"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
    >
      <mat-label>Products</mat-label>
      <input
        type="text"
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        id="product"
        class="product enterProductAdd"
        (keydown.@)="onKeydown($event)"
        tabindex="18"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option
          *ngFor="let option of filteredOptions | async"
          [value]="option"
        >
          {{
            'Product: ' +
              option.ItemNumber +
              ', Description: ' +
              option.ItemDescription
          }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field
      class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
      appearance="fill"
      *ngIf="viewminOrder"
    >
      <mat-label>Min order</mat-label>
      <input matInput formControlName="minOrder" type="number" />
    </mat-form-field>
    <mat-form-field
      *ngIf="viewminOrder"
      appearance="fill"
      class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
    >
      <mat-label>Status</mat-label>
      <mat-select formControlName="Active">
        <mat-option value="0">Inactive</mat-option>
        <mat-option value="1">Active</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-button (click)="onClearData()">Clear</button>
    <button mat-button (click)="onButtonSave()">Save</button>
  </div>
  <div
  *ngIf="!viewform"
    [formGroup]="formWarehouseLocationAddWithout"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  >
  <mat-form-field
 
  appearance="fill"
  class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
>
  <mat-label>Select location</mat-label>
  <mat-select formControlName="location">
    <mat-option *ngFor="let item of ArrayLocations" [value]="item.id">{{
      item.Location
    }}</mat-option>
  </mat-select>
</mat-form-field>
<button mat-button (click)="onButtonSaveWithout()">Save</button>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <table  *ngIf="viewform" class="table table-success table-striped-columns">
      <thead>
        <tr>
          <th>Option</th>
          <th>Customer</th>
          <th>Item number</th>
          <th>Item Description</th>
          <th>Location</th>
          <th>Min</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of ResponseWarehouseProductsLocation">
          <td>
            <button mat-button (click)="onEditarLocationProducts(item)">
              Edit
            </button>
          </td>
          <td>{{ onsearchtextcustomer(item.tblCustomerID) }}</td>
          <td>{{ item.itemNumber }}</td>
          <td>{{ item.itemDescription }}</td>
          <td>{{ item.location }}</td>
          <td>{{ item.minOrder }}</td>
          <td>{{ item.active }}</td>
        </tr>
      </tbody>
    </table>
    <table  *ngIf="!viewform" class="table table-success table-striped-columns">
      <thead>
        <tr>
          <th>Option</th>
         
          <th>Location</th>
          <th>Date</th>
        
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of ResponseWarehouseProductsLocationWitout">
          <td>
            <button mat-button (click)="onDeleteLocationWarehouseWithout(item)">
              Delete
            </button>
          </td>
          
          <td>{{ item.location }}</td>
          <td>{{ item.createdDate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div mat-dialog-actions></div>
